import {makeAutoObservable, runInAction} from 'mobx';
import {fromPromise, IPromiseBasedObservable} from 'mobx-utils';

export class CreateFormStore<F> {

    initFormData?: F;
    formData?: F;
    submitStatus: IPromiseBasedObservable<{
        state: 'pending' | 'resolved' | 'rejected',
        value: F
    }> | null = null;

    constructor(initFormData: F) {
        this.initFormData = initFormData;
        this.resetFormData();
        makeAutoObservable(this);
    }

    resetFormData = () => {
        this.formData = {...this.initFormData} as F;
    }

    setFormData = (inputData: F) => {
        this.formData = {...this.formData, ...inputData};
    };

    submitForm = async (saveFormApiCall: (data: F) => Promise<never>) => {
        this.submitStatus = fromPromise(
            saveFormApiCall(this.formData!).then((result) => {
                runInAction(() => {
                    this.resetFormData();
                });
                return result;
            }).catch((error) => {
                throw error;
            })
        );
    };

}